// Globally register all base components for convenience, because they
// will be used very frequently.

import Vue from 'vue'

// https://webpack.js.org/guides/dependency-management/#require-context
const requireComponent = require.context(
  '.',
  true,
  /[\w-]+\.vue$/
)

// For each matching file name...
requireComponent.keys().forEach(path => {
  const componentConfig = requireComponent(path)
  const fileName = componentConfig.default.name
  Vue.component(fileName, componentConfig.default || componentConfig)
})
